/* eslint-disable */
import React, { Component } from 'react'


import Svg,{
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
 
  Use,
  Defs,
  Stop
} from 'react-native-svg';

export const SvgVideo = ({size }) => {
    return (  <Svg width={size} height={size} viewBox="0 0 16 18">
    <G  fillOpacity = '0.75' id="Page-1" stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
        <G id="play-copy" fill="#FFFFFF">
            <Path d="M15.3306228,9.88378792 L1.46788772,17.222883 L1.46788772,17.222883 C0.979785132,17.4812902 0.374619336,17.2950854 0.116212084,16.8069828 C0.0398967339,16.6628316 -1.42331519e-15,16.5022012 -1.44328993e-15,16.3390951 L0,1.66090494 L-3.33066907e-16,1.66090494 C-1.55438584e-16,1.10862019 0.44771525,0.660904945 1,0.660904945 C1.16310612,0.660904945 1.3237365,0.700801679 1.46788772,0.777117028 L15.3306228,8.11621208 L15.3306228,8.11621208 C15.8187254,8.37461934 16.0049303,8.97978513 15.746523,9.46788772 C15.6527161,9.64507851 15.5078136,9.78998103 15.3306228,9.88378792 Z" id="Shape"/>
        </G>
    </G>
</Svg>)
}

